import React from 'react';
import { Route } from 'react-router-dom';

import AuthenticationLayer from './AuthenticationLayer';
import { DASHBOARD_BASE_PATH } from '../../constants/paths';

class DashboardLayout extends React.Component {
  render(){
    return (
      <Route path={DASHBOARD_BASE_PATH} component={AuthenticationLayer}/>
    );
  }
}

export default DashboardLayout;
